import React from 'react';

import { DownOutlined, RightOutlined } from '@ant-design/icons';

import {
  ChildrenContainer,
  IconContainer,
  ItemContainer,
  ItemRootContainer,
  LabelContainer,
  RootContainer,
} from './styled';
import { ITreeMenuProps, TTreeMenuItemProps } from './types';

const TreeMenuItem: React.FC<TTreeMenuItemProps> = (props) => {
  const { itemKey, label, children, openKeys, selectedKey, onClick } = props;
  const isOpen = openKeys.includes(itemKey);
  const isSelected = selectedKey === itemKey;
  let icon;
  const hasChildren = !!children;
  if (hasChildren) {
    icon = <RightOutlined />;
  }
  if (hasChildren && isOpen) {
    icon = <DownOutlined />;
  }
  const handleItemClick = () => {
    onClick && onClick(itemKey);
  };
  return (
    <ItemRootContainer>
      <ItemContainer selected={isSelected} onClick={handleItemClick}>
        {icon && <IconContainer>{icon}</IconContainer>}
        <LabelContainer>{label}</LabelContainer>
      </ItemContainer>
      {hasChildren && isOpen && (
        <ChildrenContainer>
          {children.map((c) => (
            <TreeMenuItem
              {...c}
              key={c.itemKey}
              openKeys={openKeys}
              selectedKey={selectedKey}
              onClick={onClick}
            />
          ))}
        </ChildrenContainer>
      )}
    </ItemRootContainer>
  );
};

export const TreeMenu: React.FC<ITreeMenuProps> = (props) => {
  const { items, ...others } = props;
  if (!items || items.length === 0) {
    return <RootContainer style={props.style} />;
  }
  return (
    <RootContainer style={props.style}>
      {items.map((i) => (
        <TreeMenuItem {...others} {...i} key={i.itemKey} />
      ))}
    </RootContainer>
  );
};
